import * as Honeybadger from '@honeybadger-io/js';
import { createReducer, on } from '@ngrx/store';
import { FirebaseUser } from '@vmspdb/ui/domain';
import * as LogRocket from 'logrocket';
import type { AuthTokenClaims } from './auth.actions';
import * as AuthActions from './auth.actions';

export const authFeatureKey = 'auth';

export interface AuthState {
  loading: boolean;
  projectID: string;
  user?: FirebaseUser;

  /**
   * Claims only. A slice persisted before the encoded token was removed may
   * still carry a stale `token.token` string; the next `setAuthToken`
   * overwrites it and nothing reads it.
   */
  token?: AuthTokenClaims;
}

export const initialAuthState: AuthState = {
  loading: true,
  projectID: '',
};

export const authReducer = createReducer(
  initialAuthState,

  on(AuthActions.loadAuths, (state): AuthState => state),
  on(AuthActions.noopAuth, (state): AuthState => state),
  on(AuthActions.setAuthUser, (state, props): AuthState => {
    LogRocket.identify(props.user.uid, {
      name: `${props.user.displayName ?? props.user.uid} [${state.projectID}]`,
      verified: props.user.emailVerified,
      provider: props.user.providerId,
      email: props.user.email ?? '',
    });
    Honeybadger.setContext({
      user_id: props.user.uid,
      name: `${props.user.displayName ?? props.user.uid} [${state.projectID}]`,
      verified: props.user.emailVerified,
      provider: props.user.providerId,
      email: props.user.email ?? '',
    });
    return {
      ...state,
      loading: false,
      user: props.user,
    };
  }),
  on(AuthActions.setAuthToken, (state, props): AuthState => ({
    ...state,
    token: props.token ?? undefined,
  })),
  on(AuthActions.setAuthProjectID, (state, props): AuthState => ({
    ...state,
    projectID: props.projectID,
  })),
  on(AuthActions.resetAuth, (state: AuthState): AuthState => {
    Honeybadger.clear();
    return {
      ...state,
      loading: true,
      token: undefined,
      user: undefined,
    };
  }),
);
